import React from 'react';

function EmptyMessage() {
    return (
        <div className="emptyMessageCOntainer">
            <h3 className="emptyMessage animate-charcter">Please Select Gym!</h3>
        </div>
    );
}

export default EmptyMessage;